import React, { Component } from "react";
import PropTypes from "prop-types";
import FilterHeader from "../../../components/deadlines/table/FilterHeader";
import moment from "moment";
import "./style.css";

class FilterCalendar extends Component {
  static propTypes = {
    dateSelected: PropTypes.string,
    filterTypeCalendar: PropTypes.func,
    onChangeDateFilter: PropTypes.func,
    deadlinesView: PropTypes.string,
    filtersCalendar: PropTypes.object,
    setCustomersView: PropTypes.func,
    customersView: PropTypes.string,
    classifierCompanySelected: PropTypes.string,
    myType: PropTypes.string
  };

  constructor(props) {
    super(props);
    let today = new Date();

    let monthNameSel = props.dateSelected
      ? moment(props.dateSelected).format("MMMM")
      : null;
    monthNameSel = monthNameSel
      ? monthNameSel.charAt(0).toUpperCase() + monthNameSel.slice(1)
      : today.getMonth();

    let yearSel = props.dateSelected
      ? moment(props.dateSelected).format("YYYY")
      : today.getFullYear();

    this.state = {
      filterByFiscaliPianificate: localStorage.getItem("filterByFiscaliPianificate")
        ? localStorage.getItem("filterByFiscaliPianificate") === "true"
        : true,
      monthsOption: null, // per evitare il bug dei filtri mese anno vuoto metto in stato componente e popolo al componentMount
      monthSelected: monthNameSel,
      yearsOption: null,
      yearSelected: yearSel,
      queryParameters: {
        ...localStorage.getItem("queryParameters"),
        scope:
          localStorage.getItem("queryParameters") &&
          localStorage.getItem("queryParameters") !== "undefined"
            ? localStorage.getItem("queryParameters").split(",")
            : []
      }
    };
  }

  onChangeFilter(name, value) {
    const { filterTypeCalendar } = this.props;
    const { queryParameters } = this.state;

    switch (name) {
    case "confirmed":
      if (value) {
        queryParameters["confirmed"] = null;
      } else {
        queryParameters["confirmed"] = true;
      }
      break;
    case "scopes":
      if (value.indexOf("all") > -1) {
        delete queryParameters["scope"];
      } else {
        if (value.length === 1) {
          queryParameters["scope"] = value[0];
        } else {
          queryParameters["scope"] = value;
        }
      }
      break;
    default: {
      break;
    }
    }

    localStorage.setItem("queryParameters", queryParameters["scope"]);
    this.setState({ queryParameters, hasMoreItems: true });
    filterTypeCalendar(
      queryParameters["scope"],
      queryParameters["confirmed"],
      queryParameters["expired"]
    );
  }
  render() {
    const { queryParameters } = this.state;

    const {
      dateSelected,
      filterTypeCalendar,
      onChangeDateFilter,
      setCustomersView,
      customersView,
      classifierCompanySelected,
      myType,
      balanceDetailDialog,
      setBalanceDetailDialog
    } = this.props;
    // let scopes =
    //   queryParameters.scope && queryParameters.scope.length > 0
    //     ? queryParameters.scope.split(",")
    //     : [];
    return (
      <div style={{ display: "flex", width: "100%" }}>
        <div style={{ flex: "1 1 auto" }}>
          <FilterHeader
            myType={myType}
            filterTypeCalendar={filterTypeCalendar}
            dateSelected={dateSelected}
            customerView={
              localStorage.getItem("customerViewType") || "calendar"
            }
            scopes={queryParameters.scope}
            onChangeDateFilter={onChangeDateFilter}
            onFiltersChange={this.onChangeFilter.bind(this)}
            queryParameters={queryParameters}
            setCustomersView={setCustomersView}
            customersView={customersView}
            classifierCompanySelected={classifierCompanySelected}
            balanceDetailDialog={balanceDetailDialog}
            setBalanceDetailDialog={setBalanceDetailDialog}
          />
        </div>
      </div>
    );
  }
}

export default FilterCalendar;
